<template>
	<div class="tabbar-item" @click="go()">
		<div v-show="select" class="tabbar-item-icon">
			<slot name="icon_select" >111</slot>
		</div>
		<div v-show="!select">
			<slot name="icon_unselect" >111</slot>
		</div>
		<div v-show="select" class="tabbar-item-text" :style="{color:textcolor}">
			<slot name="text">111</slot>
		</div>
		<div v-show="!select" class="tabbar-item-text" style="color:#8a8a8a">
			<slot name="text">111</slot>
		</div>
		
	</div>
</template>

<script>
	export default{
		data() {
			return {
				//select:false
			}
		},
		props:{
			url:String,
			textcolor:{
				type:String,
				default:"skyblue"
			}
			
		},
		methods:{
			go(){
				this.$router.push(this.url);
			}
		},
		computed:{
			select(){
				//console.log(this.$route.path+ "ss"+ this.url)
				return this.$route.path == this.url;
			}
		}
	}
</script>

<style>
	.tabbar-item{
		height: 40px;
	}
	.tabbar-item-icon{
		height: 28px;
	}
	.tabbar-item img{
		height: 28px;
		width: 28px;
	}
	.tabbar-item-text{
		height: 12px;
		
	}
</style>
